<template>
  <div class="basket_button">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M15.8333 7.49999L15.2367 15.2556C15.1032 16.9923 13.655 18.3333 11.9132 18.3333H8.08677C6.34498 18.3333 4.89684 16.9923 4.76326 15.2556L4.16667 7.49999M17.5 5.83332C15.3351 4.77831 12.7614 4.16666 10 4.16666C7.23862 4.16666 4.66493 4.77831 2.5 5.83332M8.33333 4.16666V3.33332C8.33333 2.41285 9.07953 1.66666 10 1.66666C10.9205 1.66666 11.6667 2.41285 11.6667 3.33332V4.16666M8.33333 9.16666V14.1667M11.6667 9.16666V14.1667" stroke="#656565" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
  </div>
</template>

<script>

export default {
  name : "BasketButton",
  props : {
    text : String
  },
  data() {
    return{

    }
  },
}
</script>

<style scoped>
.basket_button {
  cursor: pointer;
  display: flex;
}
</style>